import qs from 'query-string';

export function obterParametrosPorPrefixo(
  prefixo,
  search = window.location.search
) {
  return Object.fromEntries(
    Object.entries(qs.parse(search))
      .filter(([chave]) => chave.startsWith(prefixo))
      .map(([chave, valor]) => [chave.slice(prefixo.length), valor])
  );
}

export function aplicarValorCampoCustomizadoUrl(
  itemCC,
  valorUrl,
  opcoesEmConjunto = false
) {
  if (!itemCC.campo?.multiSelecao || valorUrl == null || valorUrl === '') {
    return { ...itemCC, valor: valorUrl };
  }

  const campo = itemCC.campo;
  const opcoesTabela = campo.opcoesTabela || [];
  const opcoesPorId = new Map(
    opcoesTabela.map((opcao) => [String(opcao.id), opcao])
  );
  const idsOpcoesUrl = [
    ...new Set(
      (Array.isArray(valorUrl) ? valorUrl : [valorUrl])
        .flatMap((valor) => String(valor).split(';'))
        .map((id) => id.trim())
        .filter(Boolean)
    ),
  ];

  const valores = idsOpcoesUrl.map(
    (id) => opcoesPorId.get(id) || { id, descricao: id }
  );
  const opcoesAusentes = valores.filter(
    (opcao) => !opcoesPorId.has(String(opcao.id))
  );

  return {
    ...itemCC,
    valor: '',
    opcoesEmConjunto,
    campo: {
      ...campo,
      opcoesTabela: [...opcoesTabela, ...opcoesAusentes],
      valores,
    },
  };
}
